<template>
	<v-card class="elevation-0">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-text class="black--text py-3">
            <div class="text-body-2 font-weight-medium mb-2">Vendedora</div>
            <v-chip
              label
              outlined
              color="deep-purple darken-1"
              class="vendedora-chip px-3 py-2"
              :class="{ 'vendedora-chip--active': vendedoras.length && !cargar }"
              :disabled="cargar || !vendedoras.length"
              @click="abrirDialogVendedora"
            >
              <v-icon left small color="deep-purple darken-1">mdi-account-tie</v-icon>
              <span class="vendedora-chip__nombre text-truncate">{{ nombreVendedoraMostrada }}</span>
              <v-icon right small color="deep-purple darken-1" class="ml-1">mdi-pencil</v-icon>
            </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- WhatsApp recibo: deshabilitado temporalmente
    <v-row>
      <v-col cols="12">
        <v-alert dense outlined type="warning" class="mb-0">
          <div class="d-flex align-start">
            <v-icon small class="mr-2 mt-1">mdi-whatsapp</v-icon>
            <div>
              <strong>Para envío de comprobante en WhatsApp</strong><br>
              Pida a cada alumno que envíe un mensaje por WhatsApp a la línea oficial de la escuela antes de procesar el pago.
              Así queda activo en Twilio y la automatización puede enviarle el recibo sin error.
            </div>
          </div>
        </v-alert>
      </v-col>
    </v-row>
    -->
		<v-row>

      <v-col :cols="columnas" v-for="(item, i) in hermanos" :key="i">
      	<v-card class="shadowCard">
      		<v-card-text class="black--text">
		        <span ><b>Alumno:</b> {{ item.nombre }} {{ item.apellido_paterno }} {{ item.apellido_materno }} <br/></span>
		        <span ><b>Matricula:</b> Sin Matricula <br/></span>
		        <span ><b>Grupo:</b>{{ item.grupo.grupo }} <br/></span>

	        <v-divider class="my-2"></v-divider>
	        <label>Promociones</label>
	        <v-tooltip bottom color="blue" max-width="300">
	        	<template v-slot:activator="{ on, attrs }">
		        <v-autocomplete
	            :items="promociones"
	            v-model="promocion"
	            :disabled="!!(beca && beca.aprobadoSN)"
	            :readonly=" i == 0 ? false : true"
	            label="Promoción"
	            dense
	            filled
	            item-value="idpromociones"
	            item-text="nombre_promocion"
	            class="ma-2"
	            hide-details
	            clearable
	            v-bind="attrs"
	            v-on="on"
	          ></v-autocomplete>
	        	</template>
	        	<span>Aplica descuentos especiales al pago</span>
	        </v-tooltip>

		        <v-divider class="my-2"></v-divider>

		        <label><b>Datos generales del pago</b></label>
						<v-list class="transparent" dense>
				      <v-list-item class="pa-0" v-if="!promocion">
				        <v-list-item-title align="end" class="pr-2">
		              Costo del curso:
		            </v-list-item-title>

				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ precio_inicial }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="!promocion"></v-divider>

				      <v-list-item class="pa-0" v-if="descuento && !promocion">
				        <v-list-item-title align="end" class="pr-2">
		              Desc. pronto pago:
		            </v-list-item-title>

				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ descuento }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="descuento && !promocion"></v-divider>

				      <v-list-item class="pa-0" v-if="descRecomienda && !promocion">
				        <v-list-item-title align="end" class="pr-2">
		              Recomendados:
		            </v-list-item-title>
				        <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
				          <b>$ {{ descRecomienda }}</b>
                  <span v-if="descRecomiendaSaldo" class="grey--text text-caption"> · saldo ${{ descRecomiendaSaldo }}</span>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="descRecomienda && !promocion"></v-divider>

		          <v-list-item class="pa-0" v-if="descuentoHermanos && !promocion">
		            <v-list-item-title align="end" class="pr-2">
		              Descuento Hmnos:
		            </v-list-item-title>

		            <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
		              <b>$ {{ descuentoHermanos }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="descuentoHermanos && !promocion"></v-divider>


		          <v-list-item class="pa-0" v-if="pago_anterior">
		            <v-list-item-title align="end" class="pr-2">
		              Pago anterior:
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
		              <b>$ {{ pago_anterior }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="pago_anterior"></v-divider>

		          <!--
		          <v-list-item class="pa-0" v-if="bonoIaApp">
		            <v-list-item-title align="end" class="pr-2">
		              Bono IA + APP:
		            </v-list-item-title>

		            <v-list-item-subtitle class="black--text font-weight-semibold text-body-1">
		              <b>$ {{ montoBonoIaApp }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="bonoIaApp"></v-divider>
		          -->

		          <v-list-item class="pa-0" v-if="solcitaFactura">
		            <v-list-item-title align="end" class="pr-2">
		              <b>Subtotal:</b>
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="text-h6 black--text">
		              <b>$ {{ parseFloat( total_a_pagar ) + montoBonoIaApp }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="solcitaFactura"></v-divider>

		          <v-list-item class="pa-0" v-if="solcitaFactura">
		            <v-list-item-title align="end" class="pr-2">
		              <b>IVA:</b>
		            </v-list-item-title>
		            
		            <v-list-item-subtitle class="text-h6 black--text">
		              <b>$ {{ ivaConBonoIaApp }}</b>
		            </v-list-item-subtitle>
		          </v-list-item>
		          <v-divider v-if="solcitaFactura"></v-divider>

				      <v-list-item class="pa-0" v-if="bonoIaApp">
				        <v-list-item-title align="end" class="pr-2">
		              <b>Pago + IA:</b>
		            </v-list-item-title>
		            <v-list-item-subtitle class="text-h6 black--text">
				          <b>$ {{ montoBonoIaApp }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider v-if="bonoIaApp"></v-divider>

				      <v-list-item class="pa-0">
				        <v-list-item-title align="end" class="pr-2">
		              <b>Total a pagar:</b>
		            </v-list-item-title>
				        
		            <v-list-item-subtitle class="text-h6 black--text">
				          <b>$ {{ pagoFinal }}</b>
				        </v-list-item-subtitle>
				      </v-list-item>
		          <v-divider></v-divider>

				      <v-list-item class="pa-0">
				        <v-list-item-title align="end" class="pr-2">
		              <b>Total pagado:</b>
		            </v-list-item-title>

				        <v-list-item-subtitle class="text-h4 black--text" v-if="tipo_pago != 1">
		              <v-text-field
		                v-if="vistaPrevia"
		                dense
		                type="number"
		                v-model="total_pagado"
		                readonly
		              ></v-text-field>
		            </v-list-item-subtitle>

				        <v-list-item-subtitle class="text-h4 black--text" v-else>
				          <v-text-field
				            dense
				            type="number"
				            v-model="total_pagado"
				            readonly
				          ></v-text-field>
				        </v-list-item-subtitle>
				      </v-list-item>

		          <v-divider></v-divider>
				    </v-list>

			    <label>Correo del alumno</label>
			    <v-row align="center" class="ma-0">
			    	<v-col cols="12" md="8" class="py-0">
			    	  <v-tooltip bottom color="blue" max-width="300">
			    	  	<template v-slot:activator="{ on, attrs }">
			    	    <v-text-field
	            	    name="name"
	            	    label="Correo del alumno"
	            	    id="id"
	            	    v-model="item.email"
	            	    filled
	            	    hide-details
	            	    single-line
	            	    dense
	            	    v-bind="attrs"
	            	    v-on="on"
	            	  ></v-text-field>
			    	  	</template>
			    	  	<span>Ingresa el email del hermano para enviar el comprobante</span>
			    	  </v-tooltip>
			    	</v-col>

			    	<v-col cols="12" md="4" class="d-flex align-center py-0">
			    	  <v-btn
			    	    color="primary"
			    	    small
			    	    tile
			    	    block
			    	    :loading="cargar"
			    	    :disabled="!item.id_alumno || cargar"
			    	    @click="actualizarCorreoAlumnoRegistrado({ id_alumno: item.id_alumno, email: item.email, alumno: item })"
			    	  >
			    	    <v-icon left small>mdi-email-sync</v-icon>
			    	    Actualizar correo
			    	  </v-btn>
			    	</v-col>
			    </v-row>

      		</v-card-text>
      	</v-card>
			</v-col>

	    <v-divider class="my-4"></v-divider>
	    <v-row>

	    	<v-col cols="12" class="px-8">
					<v-card class="shadowCard">
						<v-card-text class="black--text align-center" align="center">
						  <div class="align-center text-h6" align="center" ><b>Total a pagar:</b>$ {{ pagoAmbosHermanos }}</div>
						</v-card-text>
					<v-card-text>
					  <v-tooltip bottom color="blue" max-width="300" v-if="vistaPrevia || tipo_pago == 1">
					  	<template v-slot:activator="{ on, attrs }">
						  <v-text-field
						    label="Total pagado"
						    v-model="pagoADividir"
						    hide-details
						    filled
						    dense
						    v-bind="attrs"
						    v-on="on"
						  ></v-text-field>
					  	</template>
					  	<span>Ingresa el monto total que el cliente pagó por todos los hermanos</span>
					  </v-tooltip>
					</v-card-text>
					</v-card>
				</v-col>

	    	<v-col cols="12" class="px-8">
	    		<v-card class="shadowCard">
	    		  <v-card-text>
	    		    <v-row>
								<v-col cols="12" md="6">
					<v-tooltip bottom color="blue" max-width="300">
						<template v-slot:activator="{ on, attrs }">
							<label v-bind="attrs" v-on="on"><b>Selecciona la forma de pago</b></label>
						</template>
						<span>Elige el método de pago del cliente (Contado o Pagos)</span>
					</v-tooltip>

						<v-radio-group
					      v-model="tipo_pago"
					      column
					      readonly
					    >
					      <v-radio
					      	v-for="(item, i) in tipos_pago"
					      	:key="i"
					        :label="item.tipo"
					        :value="item.id"
					      ></v-radio>
					    </v-radio-group>


				    <v-tooltip bottom color="blue" max-width="300" v-if="[334].includes( getdatosUsuarioERPERP.iderp )">
		          <template v-slot:activator="{ on, attrs }">
		            <span v-bind="attrs" v-on="on" style="display: inline-block;">
		              <v-checkbox
		                :label="'Bono IA + APP ( $ ' + costoBonoIaApp + ' por alumno )'"
		                v-model="bonoIaApp"
		                :value="1"
		                small
		                dense
		              ></v-checkbox>
		            </span>
		          </template>
		          <span>Marca si se compra el bono de IA + APP; se cobra a cada hermano y se suma al total</span>
		        </v-tooltip>

				    <!-- SOLICITAR FACTURA -->
		        <v-tooltip bottom color="blue" max-width="300" v-if=" ( pagoFinal - total_pagado ) <= 0 || solcitaFactura">
		          <template v-slot:activator="{ on, attrs }">
		            <span v-bind="attrs" v-on="on" style="display: inline-block;">
		              <v-checkbox 
		                label="Con Factura" 
		                v-model="solcitaFactura" 
		                :value="1"
		                small
		                dense
		              ></v-checkbox>
		            </span>
		          </template>
		          <span>Marca si el cliente solicita factura fiscal</span>
		        </v-tooltip>
            <v-checkbox
              label="Con clase pregrabadas"
              v-model="conClasePregrabada"
              dense
              hide-details
              class="mt-1"
              @change="sumarClasePregrabada"
            ></v-checkbox>
            <div v-if="conClasePregrabada" class="text-body-2 mb-2">
              Costo de clase pregrabada: $ {{ precioClasePregrabada }}
            </div>

		       

						    <div>
						    	<v-tooltip bottom color="blue" max-width="300" v-if=" ( pagoFinal - total_pagado ) <= 0 ">
						    		<template v-slot:activator="{ on, attrs }">
							    	<v-btn 
					            color="green" 
					            dark 
					            small 
					            class="mr-2 text-capitalize" 
					            tile
					            v-bind="attrs"
					            v-on="on"
					          >
					            <v-icon small left>mdi-check-circle</v-icon>
					            Liquidado
					          </v-btn>
						    		</template>
						    		<span>El pago está completo y los hermanos quedan sin adeudo</span>
						    	</v-tooltip>
						    	
						    	<v-tooltip bottom color="blue" max-width="300" v-if="beca">
						    		<template v-slot:activator="{ on, attrs }">
					          <v-btn color="green" dark small class="text-capitalize" v-bind="attrs" v-on="on">Beca del {{ beca.becaTotal }}% </v-btn>
						    		</template>
						    		<span>El alumno cuenta con una beca aplicada a su inscripción</span>
						    	</v-tooltip>
						    	<v-chip v-if="hermanos[0] && hermanos[0].folio_rh" small outlined color="primary" class="ml-2">{{ hermanos[0].folio_rh }}</v-chip>
						    </div>

						    <v-tooltip bottom color="blue" max-width="300" v-if="[28,334].includes( getdatosUsuarioERPERP.iderp )">
						        <template v-slot:activator="{ on, attrs }">
						          <v-btn 
						            color="orange"
						            dark
						            class="mb-6 mt-2"
						            tile
						            small
						            @click="getPrecioPagar()"
						            v-bind="attrs"
						            v-on="on"
						          >
						            <v-icon left small>mdi-cash-lock-open</v-icon>
						            Calcular costo
						          </v-btn>
						        </template>
						        <span>Calcula el monto final considerando descuentos y promociones</span>
						      </v-tooltip>

								</v-col>

								<v-col cols="12" md="6" v-if="tipo_pago">
					        <v-card-text align="center" class="pa-0">
					          <div v-if="!file">
					            <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
					              <div class="dropZone-info" @drag="onChange">
					                <span class="fa fa-cloud-upload dropZone-title"></span>
					                <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
					                <div class="dropZone-upload-limit-info">
					                  <div>Extensión: png, jpg, jpeg, svg</div>
					                  <div>Tamaño máximo: 10 MB</div>
					                </div>
					              </div>
					              <input type="file" @change="onChange">
					            </div>
					          </div>

					          <v-tooltip bottom color="blue" max-width="300" v-if="file">
				            <template v-slot:activator="{ on, attrs }">
				              <v-btn color="red" class="mb-2" dense @click="removeFile" fab small dark v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
				            </template>
				            <span>Eliminar el comprobante de pago cargado</span>
				          </v-tooltip>
					          <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
					        </v-card-text>

								</v-col>

								<v-col cols="12" v-if="tipo_pago && tipo_pago != 1">
							    <v-row>
							    	<v-col cols="12" md="4">
							    		<label>Aut. Clave Rastreo</label>
							    		<v-tooltip bottom color="blue" max-width="300">
							    			<template v-slot:activator="{ on, attrs }">
								          <v-text-field
								            filled
								            dense
								            single-line
								            v-model="aut_clave_rastreo"
								            v-bind="attrs"
								            v-on="on"
								          ></v-text-field>
							    			</template>
							    			<span>Ingresa la autorización o clave de rastreo de la transferencia</span>
							    		</v-tooltip>
							    	</v-col>

							    	<v-col cols="12" md="4">
						          <label>Folio Oper.</label>
						          <v-tooltip bottom color="blue" max-width="300">
						          	<template v-slot:activator="{ on, attrs }">
							          <v-text-field
							            filled
							            dense
							            single-line
							            v-model="folio_operacion"
							            v-bind="attrs"
							            v-on="on"
							          ></v-text-field>
						          	</template>
						          	<span>Ingresa el número de folio de la operación bancaria</span>
						          </v-tooltip>
							    	</v-col>

							    	<v-col cols="12" md="4">
						          <label>Cuenta</label>
						          <v-tooltip bottom color="blue" max-width="300">
						          	<template v-slot:activator="{ on, attrs }">
							          <v-text-field
							            filled
							            dense
							            single-line
							            v-model="cuenta"
							            v-bind="attrs"
							            v-on="on"
							          ></v-text-field>
						          	</template>
						          	<span>Ingresa la cuenta bancaria donde se depositó</span>
						          </v-tooltip>
							    	</v-col>
							    </v-row>
								</v-col>
	    		    </v-row>
	    		  </v-card-text>
	    		</v-card>
	    	</v-col>
	    </v-row>

		</v-row>

		<v-row>
    	<v-col cols="12" class="px-8">
    		<v-card class="shadowCard">
    			<v-alert
            text
            color="info"
          >
            <h3 class="text-h6">
              HOJA DE PROCEDIMIENTO DE VALIDACION DE PROMOCIONES PARA COMISIONES
            </h3>
            <br/>
            <div>
              La hoja de términos y condiciones la podrá  descargar en el apartado de DOCS 2025 con el nombre de "Términos y condiciones de promoción" para que el cliente pueda firmarla , recuerde que si la hoja no esta Ingresada de manera correcta en sistema NO SE PODRA LIBERAR SU COMISION
            </div>
          </v-alert>
    		</v-card>
    	</v-col>
    </v-row>

    <v-row v-if="!( pagoFinal - parseFloat(total_pagado)  >= -5  )">
      <v-col cols="12">
        <v-alert
          dense
          outlined
          type="error"
        >
          No puedes agregar un pago mayor al adeudo, el restante se debe ingresar en el siguiente grupo
        </v-alert>
      </v-col>
    </v-row>

		<v-card-actions class="pb-0 mt-6">
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="black"
            dark
            @click="steppers.paso = 2"
            tile
            small
            class="text-capitalize"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-chevron-double-left</v-icon>
            regresar
          </v-btn>
        </template>
        <span>Volver al paso de selección de grupo</span>
      </v-tooltip>
      <v-spacer></v-spacer>

      <!-- Botón de procesar -->
      <v-tooltip bottom color="blue" max-width="300" v-if="!noPago && ( pagoFinal- parseFloat(total_pagado) ) >= 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            small
            dark
            class="text-capitalize"
            @click="procesarPago()"
            tile
            :disabled="cargar"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-cash-check</v-icon>
            Procesar
          </v-btn>
        </template>
        <span>Procesar la inscripción y registrar el pago de los hermanos</span>
      </v-tooltip>
    </v-card-actions>

    <!-- DIALOGO PARA CONFIRMAR EL CORREO DEL ALUMNO -->
    <v-dialog
      v-model="dialogConfirmaCorreo"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          Correo a donde se enviará el recibo de pago
        </v-card-title>
        <v-card-text>
          <v-text-field
            name="name"
            label="label"
            id="id"
            v-model="alumno.email"
            filled
            v-if="alumno"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            @click="dialogConfirmaCorreo = false, $emit('terminarProceso')"
            tile
            dark
            small
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="enviarComprobante()"
            tile
            dark
            small
          >
            <v-icon left small>mdi-content-save</v-icon>
            Actualizar y enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO PARA CONFIRMAR EL CORREO DEL ALUMNO -->
    <v-dialog
      v-model="dialogSiguientepago"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h6">
          Deseas realizar el pago del siguiente hermano? 
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            @click="cancelar()"
            rounded
            dark
            small
          >
            NO
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            @click="dialogSiguientepago = false"
            rounded
            dark
            small
          >
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCambiarVendedora"
      max-width="440"
      scrollable
    >
      <v-card>
        <v-card-title class="text-subtitle-1 pb-2">
          Cambiar vendedora
        </v-card-title>
        <v-card-text class="pt-2">
          <v-autocomplete
            :items="vendedoras"
            v-model="idVendedoraPendiente"
            label="Buscar vendedora"
            dense
            filled
            hide-details
            item-value="id_usuario"
            :item-text="textoVendedora"
            clearable
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-btn text @click="cerrarDialogVendedora">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="deep-purple darken-1"
            dark
            depressed
            @click="confirmarCambioVendedora"
          >
            <v-icon left small>mdi-check</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar || procesandoPago"/>

	</v-card>
</template>
<script>
import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import procesoPagoCarga from '@/mixins/procesoPagoCarga'
  import clasePregrabadaPago from '@/mixins/clasePregrabadaPago'
  import leerImagenes    from '@/mixins/leerImagenes'
  import bonoIaApp       from '@/mixins/bonoIaApp'
  import inscripcionReciboContacto from '@/mixins/inscripcionReciboContacto'

  const convertir = require('numero-a-letras');
  import { jsPDF } from "jspdf";
	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, leerImagenes, inscripcionReciboContacto, bonoIaApp, clasePregrabadaPago, procesoPagoCarga ],

  	props:[
			'hermanos',
			'steppers',
			'tutor',
			'dialogAddAlumno'
	  ],

    data: () => ({
    	escuela: 2,

    	alumno:{},
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      precio_inicial:0,
			descuento:0,
			total_a_pagar:0,

  		tipo_pago: 1,

			sucursal:null,
			total_pagado:0,

			label:'',
      archivos:null,
      vistaPrevia: null,
      textoImagen:'',
      monto:0,
      isPracticaja: false,
      isTransferencia:false,
      isSeven: false,
      isOXXO: false,
      isWeb:false,
      isTarjeta:false,
      isSantander: false,
      isDirectoBancoBBVA: false,
      isDirectoBANREGIO: false,
      file: '',
      dragging: false,
      pago_anterior:0,
      banco:'',

      texto_completo:'',

      saldoFavor: 0,
      tieneSaldoFavor: false,

      fechapago: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      tipos_pago:[
      	{ id: 1, tipo: 'EFECTIVO'},
      	{ id: 2, tipo: 'DEPOSITO / TRANSFERENCIA'},
      	{ id: 4, tipo: 'TARJETA' },
      ],

      dialogConfirmaCorreo:'',

      beca: null,
      pagoRealizao:0,

      pagosCursos:[],

      myState2: {
        pdf:         null,
        currentPage: 1,
        zoom:        2
      },
      solcitaFactura:0,
      saldoFactura: 0,
      descuentoRecomendados:[],
      descRecomienda:0,
      descRecomiendaSaldo:0,
      descuentosEspeciales:[],
      noPago:false,
      posicionHermano: 0,
      descuentoHermanos: 0,
      dialogSiguientepago: false,
      promociones:[],
      promocion: null,
      pagoADividir: 0,
      aut_clave_rastreo:null,
			folio_operacion:null,
			cuenta:null,
			image_id: 0,
      monto_imagen: 0,
      vendedoras: [],
      vendedora_actual: null,
      id_usuario_vendedora: null,
      dialogCambiarVendedora: false,
      idVendedoraPendiente: null,

    }),

    computed: {

    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
      
    	extension() {
        return (this.file) ? this.file.name.split('.').pop() : '';
      },

      adeudo( ){
        const restante = this.pagoFinal - parseFloat(this.total_pagado)
        if( restante > 0 )
          return restante.toFixed(2)
        else
          return 0
      },

      columnas( ){

      	return ( 12 / this.hermanos.length  ).toFixed(0)

      },

      pagoFinal( ){


      	let pagar = 0

      	if( this.promocion ){

      		const existePromocion = this.promociones.find( el => el.idpromociones == this.promocion )

      		pagar = existePromocion ? existePromocion.costo : 0

      	}else{
      		
      		pagar = (parseFloat(this.total_a_pagar) - parseFloat(this.pago_anterior) - parseFloat(this.descuentoHermanos) + parseFloat(this.saldoFactura))

      	}

      	return parseFloat( pagar ) + this.totalBonoIaApp


      },

      pagoAmbosHermanos( ){
      	return ( this.pagoFinal * this.hermanos.length ).toFixed(2)
      },

      nombreVendedoraMostrada () {
        if (this.id_usuario_vendedora == null || this.id_usuario_vendedora === '') {
          return this.vendedoras.length ? 'Seleccionar vendedora' : 'Sin vendedoras disponibles'
        }
        const v = this.vendedoras.find((x) => x.id_usuario === this.id_usuario_vendedora)
        return v ? this.textoVendedora(v) : 'Seleccionar vendedora'
      },
    },

    watch: {
      hermanos: {
        immediate: true,
        handler ( list ) {
          if ( !list || !list.length ) return
          // WhatsApp recibo: deshabilitado temporalmente
          // list.forEach( ( item, idx ) => {
          //   if ( !item.celular_whatsapp ) {
          //     const celular = this.inicializarCelularWhatsAppPago( item, '' )
          //     if ( celular ) this.$set( list[idx], 'celular_whatsapp', celular )
          //   }
          // } )
        },
      },

      solcitaFactura ( val ){
        if( val ){
          this.saldoFactura = ((parseFloat(this.total_a_pagar)  - parseFloat(this.descuentoHermanos)  - parseFloat( this.saldoFavor )) *.16).toFixed(2)

          let grupo = this.grupo

          if( this.grupo.length ){
            grupo = this.grupo[0]
          }

          if( grupo.factura ){
            this.saldoFactura = ( (parseFloat(this.precio_inicial) - parseFloat(this.descuento) - parseFloat(descuentoHermanos) ) * .16).toFixed(2)
          }

        }else{ this.saldoFactura = 0 }

      },

      total_a_pagar( ){
        if( this.saldoFactura ){
          this.saldoFactura = ( this.total_a_pagar * .16 ).toFixed(2)
        }else{ this.saldoFactura = 0 }
      },

      archivos( val ){
        this.total_pagado       = 0
        this.isPracticaja       = false
        this.isTransferencia    = false
        this.isSeven            = false
        this.isOXXO             = false
        this.isWeb              = false
        this.isTarjeta          = false
        this.isDirectoBancoBBVA = false
        this.isDirectoBANREGIO  = false
        if( !val ){ this.vistaPrevia = null } 
      },

      tipo_pago( val ){
        this.total_pagado = 0
        this.pagoADividir = 0
      },

      posicionHermano( ){
        this.getPrecioPagar()
      },

      pagoADividir( value ){
      	if( value ){
      		this.total_pagado = parseFloat( value / this.hermanos.length ).toFixed( 2 )
      	}
      },
    },

    async created () {
    	await this.getPrecioPagar( )
    	await this.getPromociones( )
      await this.getUsuarioUltimoCambioVendedoras()
    },


    methods: {
      textoVendedora (item) {
        return (item && item.nombre_completo ? String(item.nombre_completo) : '').trim()
      },

      abrirDialogVendedora () {
        if (this.cargar || !this.vendedoras.length) {
          return
        }
        this.idVendedoraPendiente = this.id_usuario_vendedora
        this.dialogCambiarVendedora = true
      },

      cerrarDialogVendedora () {
        this.dialogCambiarVendedora = false
      },

      confirmarCambioVendedora () {
        this.id_usuario_vendedora = this.idVendedoraPendiente
        this.dialogCambiarVendedora = false
      },

      getUsuarioUltimoCambioVendedoras () {
        const primero = this.hermanos && this.hermanos[0]
        const idRef = primero && primero.id_usuario_ultimo_cambio
        if (idRef == null || idRef === '') {
          this.vendedoras = []
          this.vendedora_actual = null
          this.id_usuario_vendedora = null
          return Promise.resolve()
        }

        return this.$http.get('vendedoras.list.usuario.ultimo.cambio/' + idRef).then(response => {
          this.vendedoras = response.data.vendedoras || []
          this.vendedora_actual = response.data.vendedora_actual || null
          if (this.vendedora_actual && this.vendedora_actual.id_usuario != null) {
            this.id_usuario_vendedora = this.vendedora_actual.id_usuario
          } else if (this.vendedoras.length) {
            this.id_usuario_vendedora = this.vendedoras[0].id_usuario
          } else {
            this.id_usuario_vendedora = null
          }
        }).catch(error => {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
        }).finally(() => { this.cargar = false })
      },

      getPrecioPagar( ) {

      	this.cargar = true

      	const folioRh = (this.hermanos[0] && this.hermanos[0].folio_rh) || null
      	if (folioRh) {
      		this.hermanos.forEach((h) => { h.folio_rh = folioRh })
      	}

        return this.$http.post('inscripciones.calcular.precio.hermanos', this.hermanos ).then(response=>{

        	this.precio_inicial         = response.data.precio_inicial
					this.descuento              = response.data.descuento
					this.fijarTotalBaseClase(response.data.total_a_pagar)
					this.beca                   = response.data.beca 
					if( this.beca && this.beca.aprobadoSN ) this.promocion = null // con beca el precio es fijo
          this.pago_anterior          = response.data.pago_anterior 
          this.saldoFavor             = response.data.saldoFavor 
          this.tieneSaldoFavor        = response.data.tieneSaldoFavor 
          this.pagosCursos            = response.data.pagosCursos
          this.descuentoRecomendados  = response.data.descuentoRecomendados
          this.descRecomienda         = response.data.descRecomienda
          this.descRecomiendaSaldo    = response.data.descRecomiendaSaldo || 0
          this.descuentosEspeciales   = response.data.descuentosEspeciales
          this.descuentoHermanos      = response.data.descuentoHermanos
          this.aplicarBonoIaAppDesdeRespuesta( response.data )

        	this.cargar = false
          this.noPago = false
        }).catch( error =>{
          this.noPago = true
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPromociones( ) {

      	this.cargar = true

        return this.$http.get('promociones.list' ).then(response=>{

        	this.promociones = response.data.filter( el => el.escuela == this.getEscuela && el.promocion.match('Hermanos') )

        	console.log( this.hermanos[0].grupo.grupo.match('TEENS') )

        	if( this.hermanos[0].grupo.grupo.match('TEENS') ){

        		this.promociones = this.promociones.filter( el => el.promocion.match('TEENS') )

        		console.log( this.promociones )

        	}else{

        		this.promociones = this.promociones.filter( el => !el.promocion.match('TEENS') )

        	}

        	if( this.hermanos[0].grupo.grupo.match('ONLINE') ){

        		this.promociones = this.promociones.filter( el => el.promocion.match('Online') )

        	}else{

        		this.promociones = this.promociones.filter( el => !el.promocion.match('Online') )

        	}


        	if( this.hermanos[0].grupo.grupo.match('SABATINO') ){


        		if( this.hermanos[0].grupo.hora_inicio < "12:00:00"){

        			this.promociones = this.promociones.filter( el => el.promocion.match('Sabatino') )

        		}else{
        			
        			this.promociones = this.promociones.filter( el => !el.promocion.match('Sabatino') )

        		}
        		

        	}else{

        		this.promociones = this.promociones.filter( el => !el.promocion.match('Sabatino') )

        	}


        	this.cargar = false
          this.noPago = false
        }).catch( error =>{
          this.noPago = true
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      seleccionarAlumno( value ){

        let payload = {
          grupo: value, 
          hermanos: false
        }

      	this.$emit('alumnoSeleccionado', value )
      },

      realizarPago( data ){
        return new Promise((resolve,reject)=>{
          this.$http.post('registrar.grupo.alumno', data ).then( response => {
          this.guardarPendienteClase(response)
          if ( this.manejarRespuestaPagoIdempotente( response ) ) { resolve(response.data); return }
            // Convertir el monto en texto

            this.url = axios.defaults.baseURL + 'recibo-pago/' + response.data.ingreso.id + '.pdf'

            window.open( this.url )

            resolve('Inscrito correctamente')
          }).catch( error =>{
					if ( this.manejarErrorPagoDuplicado( error ) ) { reject( error ); return }

            reject( error )
          }).finally( () => { this.cargar = false })
        })
      },

      grabarImagen( ){
        return new Promise((resolve,reject)=>{
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo
          formData.append("file", this.file);

          this.$http.post("grabar.comprobante", formData).then( response => {
            resolve( response.data ) 
          }).catch( error =>{
            reject( error )
          }).finally( () => { this.cargar = false })
        })
      },

      validarPagosHermanos( ){
        if (this.beca && this.beca.aprobadoSN && Number(this.beca.becaTotal) >= 100) {
          return true
        }
        const totalADividir = parseFloat(this.pagoADividir)
        const totalPagado = parseFloat(this.total_pagado)
        const pagosHermanos = this.hermanos.map(() => totalPagado)
        const pagoEnCero = !Number.isFinite(totalADividir) || totalADividir <= 0
          || pagosHermanos.some((pago) => !Number.isFinite(pago) || pago <= 0)

        if( pagoEnCero ){
          this.validarErrorDirecto('Uno de los pagos de hermanos se esta ingresando en 0, refresca la pantalla')
          return false
        }

        return true
      },

      procesarPago( ){
        return this.ejecutarProcesoPago( () => this.procesarPagoInterno() )
      },

      async procesarPagoInterno( ){

      	// Vallidar los correos de los alumnos
      	for( const i in this.hermanos ){

      		this.hermanos[i].email = this.normalizarEmailRecibo( this.hermanos[i].email )
      		const { email } = this.hermanos[i]

      		const errorContacto = this.validarContactoReciboPago( email )
      		if ( errorContacto ) {
      			return this.validarErrorDirecto( `Hermano ${ parseInt(i, 10) + 1 }: ${ errorContacto }` )
      		}

      	}


      	if ( this.hermanosConWhatsAppRecibo( this.hermanos ) && !this.confirmarWhatsAppReciboActivo() ) {
      		return
      	}

      	if( !this.beca && this.total_pagado <= 0 ){

      		return this.validarErrorDirecto('No puedes ingresar un pago en 0')

      	}

        if( !this.validarPagosHermanos() ){

          return

        }

      	if (this.vendedoras.length && (this.id_usuario_vendedora == null || this.id_usuario_vendedora === '')) {
      		return this.validarErrorDirecto('Selecciona la vendedora')
      	}


      	this.cargar = true

      	if( this.tipo_pago != 1 && ( !this.aut_clave_rastreo || !this.folio_operacion || !this.cuenta )){

      		return this.validarErrorDirecto('Favor de llenar todos los datos del alumno')

      	}

      	// if( this.monto_imagen != this.total_pagado ){

      	// 	return this.validarErrorDirecto('El monto de la imagen, no concuerda con el monto ingresado')

      	// }

      	// Nombre del archivo que se guardo 
      	let nombre_archivo = {nombre:''}

      	// Solo es es imagen, si no, se va vacío
      	if( this.tipo_pago != 1 ){
      		nombre_archivo = await this.grabarImagen( ).then( response => response ).catch( error => { return this.validarError(error) })
      	}

      	// El curso se debe guardar por que es NI
        let guardarCurso = true

        // Limpiar la cadena de cáracteres
        this.texto_completo = this.texto_completo.replace(/[∀,∂,∃,∄,∅,∆,∇,∈,∉,∊,∋,∌,∍,∎,∏,∐,∑,∓,∔,∖,√,∛,∜,∝,∞,∟,∠,∡,∢,∣,∤,∥,∦,∧,∨,∩,∪,∫,∬,∭,∮,∯,∰,∱,∲,∳,∴,∵,∶,∷,∸,∹,∺,∻,∼,∽,∾,∿,≀,≁,≂,≃,≄,≅,≆,≇,≈,≉,≊,≋,≌,≍,≎,≏,≐,≑,≒,≓,≔,≕,≖,≗,≘,≙,≚,≛,≜,≝,≞,≟,≠,≡,≢,≣,≤,≥,≦,≧,≨,≩,≪,≫,≬,≭,≮,≯,≰,≱,≲,≳,≴,≵,≶,≷,≸,≹,≺,≻,≼,≽,≾,≿,•,ЗУЗ,З,У,ф,₴,#,*,:,$,.,/]/g,' ')

        const acentos = {'á':'a','é':'e','í':'i','ó':'o','ú':'u','Á':'A','É':'E','Í':'I','Ó':'O','Ú':'U'};

        this.texto_completo  = this.texto_completo.split('').map( letra => acentos[letra] || letra).join('').toString();

        const existePromocion = this.promociones.find( el => el.idpromociones == this.promocion )

      	const payload = {
          idempotency_key            : this.generarIdempotencyKeyPago(),
          monto_comprobante           : this.monto_imagen,
          adeudo                     : parseFloat(this.adeudo),
			    base_path                  : null,
			    comentarios                : '',
          descRecomienda             : this.descRecomienda,
			    descuento                  : this.descuento - parseFloat(this.descuentoHermanos) ,
          descuentoRecomendados      : this.descuentoRecomendados,
          descuentosEspeciales       : this.descuentosEspeciales,
          grupo                      : null,// estos se deben agregar más adelante
          guardarCurso,
			    id_alumno                  : this.alumno.id_alumno,
			    id_ciclo                   : null,// estos se deben agregar más adelante
          id_curso                   : null,// estos se deben agregar más adelante
			    id_descuento_pronto_pago   : null,
			    id_forma_pago              : this.tipo_pago,
          id_grupo                   : null,// estos se deben agregar más adelante
			    id_plantel_ingreso         : this.getdatosUsuarioERPERP.id_plantel,
			    id_tipo_descuento          : null,
			    id_tipo_ingreso            : 2,
			    id_tipo_inscripcion        : this.total_pagado >= ( parseFloat(this.total_a_pagar) + this.totalBonoIaApp ) ? 2 : 3,
			    id_usuario_ultimo_cambio   : this.getdatosUsuarioERPERP.iderp,
          idbecas                    : this.beca ? this.beca.id : 0,
          folio_rh                   : (this.hermanos[0] && this.hermanos[0].folio_rh) || null,
			    monto_adeudo_grupo         : 0,
			    monto_descuento_grupo      : parseFloat( this.descuento ) - parseFloat(this.descuentoHermanos),
			    monto_pagado_total         : parseFloat(this.total_pagado ),
			    monto_saldo_favor          : 0,
          nuevoSaldoFavor            : 0,
			    pago_completado_sn         : this.total_pagado >= (parseFloat(this.total_a_pagar) - parseFloat(this.pago_anterior) + this.totalBonoIaApp) ? 1 : 0,
			    precio_curso               : this.precio_inicial,
			    precio_grupo_con_descuento : parseFloat( this.total_a_pagar) - parseFloat(this.descuentoHermanos) + parseFloat( this.saldoFactura ) + this.totalBonoIaApp,
			    precio_grupo_sin_descuento : this.precio_inicial,
          saldoFavor                 : 0,
          solcitaFactura             : this.solcitaFactura,
          ...this.payloadBonoIaApp(),
          tieneSaldoFavor            : this.tieneSaldoFavor,
          texto_completo             : this.texto_completo,
          tipoAlumno                 : 1,
          total_pagado_alumno        : (parseFloat(this.precio_inicial) + parseFloat(this.saldoFactura) + this.totalBonoIaApp),
			    url_foto                   : nombre_archivo.nombre,
          pago_final_grupo           : parseFloat( this.pago_anterior ) + parseFloat(this.total_pagado ),
          hermanos                   : this.hermanos,
          tutor                      : this.tutor,
          unidad_negocio             : this.getEscuela,
          promocion                  : existePromocion ? existePromocion : null,
          pago_hermanos              : true,
          aut_clave_rastreo          : this.aut_clave_rastreo,
					folio_operacion            : this.folio_operacion,
					cuenta                     : this.cuenta,
					image_id                   : this.image_id,
          id_usuario_vendedora       : this.id_usuario_vendedora,
          ...this.payloadBonoIaApp(),
				}


				return this.$http.post('registrar.grupo.alumno.hermanos', payload ).then( async response => {
          this.guardarPendienteClase(response)
          if ( this.manejarRespuestaPagoIdempotente( response ) ) return

          this.cargar = false
          // Convertir el monto en texto
	          // this.noPago = true

          this.tipo_pago = 1


          for( const i in response.data ){

	          let url = axios.defaults.baseURL + 'recibo-pago/' + response.data[i].id + '.pdf'
	          window.open(url, '_blank');
          	await this.enviarComprobante( response.data[i] )
          }

          this.validarSuccess('Pagos realizados correctamente')
          this.dialogAddAlumno.estatus = false
          // this.dialogConfirmaCorreo = true

				}).catch( error =>{
					if ( this.manejarErrorPagoDuplicado( error ) ) return

					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
      },

      enviarComprobante( value ){

        const hermano = this.hermanos.find( ( h ) => h.id_alumno === value.id_alumno ) || {}

        const payload = {
          folio:                  value.id,
          alumno:                 value.alumno,
          matricula:              value.matricula,
          plantel:                this.getdatosUsuarioERPERP.plantel,
          ciclo:                  value.ciclo,
          curso:                  value.curso,
          cantidad_recibida:      this.total_pagado,
          cantidad_letra:         convertir.NumerosALetras(this.total_pagado).toUpperCase(),
          descuento_pronto_pago:  this.descuento,
          adeudo:                 this.adeudo,
          saldo_favor:            this.nuevoSaldoFavor,
          id_alumno:              value.id_alumno,
          email:                  this.normalizarEmailRecibo( hermano.email || value.email ),
          // celular:                hermano.celular_whatsapp || '', // WhatsApp recibo deshabilitado temporalmente
          twilio_asignado:        hermano.twilio_asignado || null,
          unidad_negocio:         this.getEscuela,
          fecha_pago:             this.fechapago,
          recepcion:              this.getdatosUsuarioERPERP.nombre_completo,
          solcitaFactura:         this.solcitaFactura,
          ...this.payloadBonoIaApp(),
        }


        this.cargar = true
        this.$http.post('actualizar.correo.alumno', payload ).then( response => {

          if ( hermano.id_alumno ) {
            hermano.email = this.normalizarEmailRecibo( hermano.email || value.email )
          }
          this.validarSuccess(response.data.message)


        }).catch( error =>{
         this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      cancelar( ){
        this.dialogSiguientepago = false
        this.$emit('terminarProceso')
      }
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }

  .vendedora-chip--active:not(.v-chip--disabled) {
    cursor: pointer;
    transition: background 0.15s ease, box-shadow 0.15s ease;
  }

  .vendedora-chip--active:not(.v-chip--disabled):hover {
    background: rgba(94, 53, 177, 0.09) !important;
    box-shadow: 0 1px 4px rgba(94, 53, 177, 0.2);
  }

  .vendedora-chip__nombre {
    max-width: min(260px, 72vw);
  }
</style>